import { render, staticRenderFns } from "./CreateQuiz.vue?vue&type=template&id=24cb8a02"
import script from "./CreateQuiz.vue?vue&type=script&lang=js"
export * from "./CreateQuiz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports